import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-sidenav-recent-activity',
  templateUrl: './sidenav-recent-activity.component.html',
  styleUrls: ['./sidenav-recent-activity.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidenavRecentActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
